(function () {
  const loadMoreBtns = document.querySelectorAll('.load-more-latest-posts');

  if (loadMoreBtns.length === 0) {
    return;
  }

  loadMoreBtns.forEach((btn) => {
    let page = 1;
    let settings = {};
    try {
      settings = JSON.parse(btn.getAttribute('data-settings') ?? '{}');
    } catch (error) {
      console.error('Invalid latest posts settings:', error);
      return;
    }

    const perPage = settings.perPage;
    const total = settings.total;
    const postType = settings.postType;
    const providerId = settings.providerId;
    const showDate = settings.showDate;
    const postsList = btn.closest('section')?.querySelector('.posts-list');

    if (!postsList) {
      return;
    }

    btn.addEventListener('click', function (event) {
      event.preventDefault();

      fetch(load_more_data.url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        body: new URLSearchParams({
          nonce: load_more_data.nonce,
          page: page,
          perPage: perPage,
          postType: postType,
          providerId: providerId,
          showDate: showDate,
          action: 'more_latest_posts'
        })
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.text();
        })
        .then((response) => {
          page += 1;

          if (!response.trim()) {
            btn.closest('.wp-block-buttons')?.remove();
            return;
          }

          postsList.insertAdjacentHTML('beforeend', response);

          if (page >= total) {
            btn.closest('.wp-block-buttons')?.remove();
          } else {
            btn.disabled = false;
          }
        })
        .catch((error) => {
          console.error('Error:', error);
          btn.disabled = false;
        });

      btn.disabled = true;
    });
  });
})();
